<template>
    <div class="progress border-1">
        <div
            v-for="part in parts"
            :key="part"
            class="progress-bar border-2"
        ></div>
    </div>
</template>

<script>
import $ from "jquery";
export default {
    name: 'split-progress-bar',
    props: {
        parts: {
            type: Number,
            default: 10,
        },
        maxValue: Number,
        value: Number,
    },
    watch:{
        value:function(){
            this.updateParts()
        },
        maxValue:function(){
            this.updateParts()
        }

    },
    mounted: function() {
        this.updateParts();
    },
    methods:{
        updateParts(){
            let elem = Math.floor(this.value*this.parts/this.maxValue);
            let percentage = (this.value/this.maxValue) * 100;
            let progressElem = $(`.progress-bar`).removeClass('filled-25 filled-50 filled-75 filled-100').slice(0,elem);
            if(percentage<25){
                progressElem.addClass('filled-25');
            }else if(percentage<50){
                progressElem.addClass('filled-50');
            }else if(percentage<75){
                progressElem.addClass('filled-75');
            }else{
                progressElem.addClass('filled-100');
            }
        }
    }
};
</script>

<style scoped>
.border-1 {
    border: 2px solid gray;
}
.border-2{
    border:1px solid white;
}
.progress {
    display: flex;
}
.progress-bar{
    width:100%;
    background-color: grey;
}
.progress-bar.filled-25{
    background-color: red;
}
.progress-bar.filled-50{
    background-color: rgb(245, 187, 79);
}
.progress-bar.filled-75{
    background-color: rgb(171, 224, 72);
}
.progress-bar.filled-100{
    background-color: rgb(36, 170, 36);
}

</style>
